//* 학생 알림 링크 생성
export const getUrlForStudent = (queryParams: any) => {
    let link = "/student/alarm";
    if (queryParams.media === "profile") {
        link = studentNavigateToProfile(queryParams);
    } else if (queryParams.media === "profileForAgency") {
        link = studentNavigateToProfileForAgency(queryParams);
    } else if (queryParams.media === "diary") {
        link = studentNavigateToDiary(queryParams)
    } else if (queryParams.media === 'bbs') {
        link = studentNavigateToBbs(queryParams);
    } else if (queryParams.media === "chat") {
        link = studentNavigateToChat(queryParams);
    } else if (queryParams.media === "congratulation") {
        link = studentNavigateToCongratulation(queryParams);
    }
    return link;
}

export const studentNavigateToProfile = (agencyProfileObj: any) => {
    console.log("studentNavigateToProfile", agencyProfileObj);
    if (agencyProfileObj.type === 'detail'
        || agencyProfileObj.type === 'favorite'
        || agencyProfileObj.type === 'growth'
        || agencyProfileObj.type === 'photo'
        || agencyProfileObj.type === 'following'
    ) {
        return `/student/profile/`;
    }
}

export const studentNavigateToProfileForAgency = (profileObj: any) => {
    console.log("studentNavigateToProfileForAgency", profileObj);
    if (profileObj.type === 'detail'
        || profileObj.type === 'photo'
        || profileObj.type === 'introVideo'
    ) {
        return `/student/profile/`;
    }
}

export const studentNavigateToDiary = (diaryObj: any) => {
    console.log("studentNavigateToDiary", diaryObj);
    if (diaryObj.type === 'detail'
        || diaryObj.type === 'like'
        || diaryObj.type === 'bookmark'
        || diaryObj.type === 'comment'
    ) {
        let uri = `/student/growth/diary/${diaryObj.diaryId}`;
        if (diaryObj.commentId) {
            uri += `?commentId=${diaryObj.commentId}`;
        }
        return uri;
    } else if (diaryObj.type === 'list') {
        return "/student/growth/diary";
    }
}

export const studentNavigateToChat = (params: any) => {
    console.log("studentNavigateToChat", params);
    if (params.type === "request") {
        return "/student/casting/message";
        // if (params.messageRequestId) {
        //     return "/student/casting/message?messageRequestId=" + params.messageRequestId;
        // } else {
        //     return "/student/casting/message";
        // }
    }
}

export const studentNavigateToBbs = (bbsObj: any) => {
    console.log("studentNavigateToBbs", bbsObj);
    if (bbsObj.type === 'detail'
        || bbsObj.type === 'comment'
        || bbsObj.type === 'like'
    ) {
        let uri = `/student?1=1`;
        if (bbsObj.bbsId) {
            uri += `&bbsId=${bbsObj.bbsId}`;
            if (bbsObj.type === 'like') {
                if (bbsObj.bbsCommentId) {
                    uri += `&bbsCommentId=${bbsObj.bbsCommentId}`;
                } else {
                    uri += `&type=like`;
                }
            }
        }
        if (bbsObj.commentId) {
            uri += `&commentId=${bbsObj.commentId}`;
        }
        return uri;
    }
}

export const studentNavigateToCongratulation = (congratulationObj: any) => {
    console.log("studentNavigateToCongratulation", congratulationObj);
    if (congratulationObj.type === 'like') {
        return `/student/profile`;
    }
}


export const getUrlForAgency = (queryParams: any) => {
    let link = "/agency/alarm";
    if (queryParams.media === "chat") {
        link = agencyNavigateToChat(queryParams);
    }
    return link;
}

export const agencyNavigateToChat = (params: any) => {
    console.log("agencyNavigateToChat", params);
    if (params.type === "accept") {
        return "/agency/casting/message/" + params.channelId;
    } else if (params.type === "deny") {
        return "/agency/casting/message";
    }
}

//* 코치 알림 링크 생성
export const getUrlForKoach = (queryParams: any) => {
    let link = "/koach/alarm";
    if (queryParams.media === "diary") {
        link = koachNavigateToDiary(queryParams);
    } else if (queryParams.media === "content") {
        link = koachNavigateToContent(queryParams);
    }
    return link;
}

export const koachNavigateToDiary = (diaryObj: any) => {
    console.log("koachNavigateToDiary", diaryObj);
    if (diaryObj.type === 'detail'
        || diaryObj.type === 'comment'
    ) {
        let uri = `/koach/coaching/diary`;
        if (diaryObj.diaryId) {
            // 다이어리 상세는 팝업으로 표시되므로 홈으로 이동
            uri = `/koach?diaryId=${diaryObj.diaryId}`;
        }
        if (diaryObj.commentId) {
            uri += `&commentId=${diaryObj.commentId}`;
        }
        return uri;
    } else if (diaryObj.type === 'list') {
        return "/koach/coaching/diary";
    }
    return "/koach/coaching/diary";
}

export const koachNavigateToContent = (contentObj: any) => {
    console.log("koachNavigateToContent", contentObj);
    if (contentObj.type === 'detail'
        || contentObj.type === 'like'
        || contentObj.type === 'favorite'
        || contentObj.type === 'comment'
    ) {
        return `/koach/coaching/contents/${contentObj.contentId}`;
    }
}